// extracted by mini-css-extract-plugin
export default {"blogCardWrapper":"ArticlesModule_blogCardWrapper__DI7No"};